// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"98":"00acbc99","252":"00acbc99","826":"8794d03b"}[chunkId] + ".css";
};